import React from 'react';
import {
  Field,
  SitecoreContext,
  withSitecoreContext,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';
import { Tooltip, ClickAwayListener, Button } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import './index.scss';

export type CustomTooltipProps = WithSitecoreContextProps & {
  fields: {
    'Tooltip Text': Field<string>;
  };
  disabled?: boolean;
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

export const CustomTooltip = ({
  fields,
  disabled,
  sitecoreContext,
}: CustomTooltipProps): React.JSX.Element => {
  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };
  if (fields) {
    return (
      <div className="tooltip">
        {sitecoreContext.pageEditing && (
          <>
            <p>Tooltip Component Edit Mode</p>
          </>
        )}
        <ClickAwayListener onClickAway={handleTooltipClose}>
          <div className="tooltipArea">
            <Tooltip
              PopperProps={{
                disablePortal: true,
              }}
              onClose={handleTooltipClose}
              open={open}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title={fields['Tooltip Text']?.value}
              arrow
            >
              <Button
                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                  e.stopPropagation();
                  handleTooltipOpen();
                }}
                tabIndex={-1}
                className={`tooltip-button ${disabled ? 'disabled' : ''}`}
              >
                <HelpIcon />
              </Button>
            </Tooltip>
          </div>
        </ClickAwayListener>
      </div>
    );
  } else if (!fields && sitecoreContext.pageEditing) {
    return <p>Please setup the Datasource.</p>;
  }
  return <></>;
};

export default withSitecoreContext()(CustomTooltip);
